import * as React from "react"
const AuditIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22}
    height={22}
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="#fff">
      <path
        d="M24.36 10.341a2.904 2.904 0 0 1-2.9-2.9V2H10.1c-2.21 0-4 1.79-4 4v3.638a7.037 7.037 0 0 1 1.996-.288c1.869 0 3.624.726 4.942 2.043 2.725 2.727 2.726 7.161.002 9.887a6.947 6.947 0 0 1-4.944 2.045c-.681 0-1.352-.1-1.996-.294V26c0 2.21 1.79 4 4 4h15.69c2.21 0 4-1.79 4-4V10.341zM18.448 21.03h-2.56a.9.9 0 0 1 0-1.8h2.56a.9.9 0 0 1 0 1.8zm5.3-3.389h-6.89a.9.9 0 0 1 0-1.8h6.89a.9.9 0 0 1 0 1.8z"
        data-original="#000000"
      />
      <path
        d="M8.096 21.524a5.174 5.174 0 0 0 3.67-1.518 5.198 5.198 0 0 0 0-7.341 5.2 5.2 0 0 0-7.34 0c-1.805 1.806-1.988 4.616-.572 6.64l-2.278 2.278a.9.9 0 1 0 1.272 1.273l2.279-2.279a5.16 5.16 0 0 0 2.969.947zm-2.398-7.585a3.393 3.393 0 0 1 4.794 0 3.393 3.393 0 0 1 0 4.794 3.394 3.394 0 0 1-4.795 0 3.396 3.396 0 0 1 .001-4.794zM23.261 7.44c0 .606.493 1.1 1.1 1.1h5.43v-.3c0-.8-.32-1.56-.88-2.12l-3.24-3.24A3.001 3.001 0 0 0 23.55 2h-.289z"
        data-original="#000000"
      />
    </g>
  </svg>
)
export default AuditIcon
